import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import formatPrice from 'utils/formatPrice';

const styles = theme => ({
  avatar: {
    display: 'inline-block',
    verticalAlign: 'middle',
    width: 32,
    height: 32,
    marginRight: 15,
  },
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  tableCellRoles: {
    maxWidth: 200,
  },
  tableCellPaid: {
    color: theme.palette.states.paid,
  },
  tableCellDenied: {
    color: theme.palette.states.rejected,
  },
});

const EraChartERATable = ({ eraData, onERADetailsLoad, classes }) => {
  const tableData = Object.keys(eraData).reduce((accumulator, currentPayer) => ([
    ...accumulator,
    ...Object.keys(eraData[currentPayer]).map(currentEra => ({
      'ERA': currentEra,
      'Payer': currentPayer,
      'Date': eraData[currentPayer][currentEra].Date,
      'Claims': (eraData[currentPayer][currentEra].Paid ? eraData[currentPayer][currentEra].Paid['Claims Count'] : 0)
        + (eraData[currentPayer][currentEra]['Partial Regular'] ? eraData[currentPayer][currentEra]['Partial Regular']['Claims Count'] : 0)
        + (eraData[currentPayer][currentEra].Denied ? eraData[currentPayer][currentEra].Denied['Claims Count'] : 0),
      'Patients': (eraData[currentPayer][currentEra].Paid ? eraData[currentPayer][currentEra].Paid['Patients Count'] : 0)
        + (eraData[currentPayer][currentEra]['Partial Regular'] ? eraData[currentPayer][currentEra]['Partial Regular']['Patients Count'] : 0)
        + (eraData[currentPayer][currentEra].Denied ? eraData[currentPayer][currentEra].Denied['Patients Count'] : 0),
      'Billed':  (eraData[currentPayer][currentEra].Paid ? eraData[currentPayer][currentEra].Paid['Billed Reimbs'] : 0)
        + (eraData[currentPayer][currentEra]['Partial Regular'] ? eraData[currentPayer][currentEra]['Partial Regular']['Billed Reimbs'] : 0)
        + (eraData[currentPayer][currentEra].Denied ? eraData[currentPayer][currentEra].Denied['Billed Reimbs'] : 0),
      'Paid': (eraData[currentPayer][currentEra].Paid ? eraData[currentPayer][currentEra].Paid['Paid Reimbs'] : 0)
        + (eraData[currentPayer][currentEra]['Partial Regular'] ? eraData[currentPayer][currentEra]['Partial Regular']['Paid Reimbs'] : 0),
      'Denied $': eraData[currentPayer][currentEra].Denied ? eraData[currentPayer][currentEra].Denied['Billed Reimbs'] : 0,
      'Denied #': eraData[currentPayer][currentEra].Denied ? eraData[currentPayer][currentEra].Denied['Claims Count'] : 0,
    })),
  ]), []);
  return (
    <Table className={classes.table}>
      <TableHead
        className={classes.tableHead}
      >
        <TableRow>
          <TableCell>ERA</TableCell>
          <TableCell>Payer</TableCell>
          <TableCell>Date</TableCell>
          <TableCell numeric>Claims</TableCell>
          <TableCell numeric>Patients</TableCell>
          <TableCell numeric>Billed</TableCell>
          <TableCell numeric>Paid</TableCell>
          <TableCell numeric>Denied $</TableCell>
          <TableCell numeric>Denied #</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {tableData.map(eraItem => (
          <TableRow
            key={eraItem.ERA}
            onClick={() => onERADetailsLoad(eraItem.ERA)}
            hover
          >
            <TableCell>
              {eraItem.ERA}
            </TableCell>
            <TableCell>
              {eraItem.Payer}
            </TableCell>
            <TableCell>
              {eraItem.Date}
            </TableCell>
            <TableCell numeric>
              {eraItem.Claims}
            </TableCell>
            <TableCell numeric>
              {eraItem.Patients}
            </TableCell>
            <TableCell numeric>
              {formatPrice(eraItem.Billed)}
            </TableCell>
            <TableCell
              numeric
              className={classNames({
                [classes.tableCellPaid]: eraItem.Paid > 0,
              })}
            >
              {formatPrice(eraItem.Paid)}
            </TableCell>
            <TableCell
              numeric
              className={classNames({
                [classes.tableCellDenied]: eraItem['Denied $'] > 0,
              })}
            >
              {formatPrice(eraItem['Denied $'])}
            </TableCell>
            <TableCell
              numeric
              className={classNames({
                [classes.tableCellDenied]: eraItem['Denied #'] > 0,
              })}
            >
              {eraItem['Denied #'] > 0 ? eraItem['Denied #'] : '-'}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

EraChartERATable.propTypes = {
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(EraChartERATable);



// WEBPACK FOOTER //
// ./src/components/home/EraChart/EraChartERATable.js